import AutoScroller from "./AutoScroller";

export default AutoScroller;
